import * as Actions from '../actions';

const initialState = {
	registerSuccess: false,
	loginSuccess: false,
	error: null
};

const login = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_LOGIN_SUCCESS: {
			return {
				...initialState,
				loginSuccess: true
			};
		}
		case Actions.SET_REGISTER_SUCCESS: {
			return {
				...initialState,
				registerSuccess: !state.registerSuccess
			};
		}
		case Actions.SET_ERROR: {
			return {
				...initialState,
				error: action.payload
			};
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.CLEAR_AUTH: {
			return initialState;
		}
		case Actions.SET_ACTIVE_LDAP_SERVERS: {
			return {
				...state,
				activeLdapServers: action.payload
			};
		}
		case Actions.SET_ACTIVE_OIDC_PROVIDERS:
			return {
				...state,
				activeOidcProviders: action.payload
		};
		default: {
			return state;
		}
	}
};

export default login;
